/**
 * A number typed into a form field. Only plain decimals count ("10", "12.5", ".5", "3."):
 * `Number()` alone would also take "1e2", "0x10", "Infinity" and a blank field (as 0), none of
 * which a person means as an amount.
 */

const PLAIN_DECIMAL = /^(?:\d+(?:\.\d*)?|\.\d+)$/;

/** The field's value, or NaN when it is empty or not a plain, finite decimal. */
export const parseDecimal = (text: string): number => {
  const trimmed = text.trim();
  if (!PLAIN_DECIMAL.test(trimmed)) return Number.NaN;
  const value = Number(trimmed);
  return Number.isFinite(value) ? value : Number.NaN;
};
